<div
  [ngClass]="'u-padding-0-8'"
  [ngClass.gt-sm]="'u-padding-0-24'"
  class="c-header"
  fxLayout="row"
  fxLayoutAlign="start center"
  role="banner"
>
  <div [fxShow]="true" [fxShow.gt-sm]="false" fxFlex="48px">
    <a
      (click)="showSideNav(drawer)"
      aria-label="Menu"
      i18n-aria-label="@@headerView.menuLabel"
      mat-icon-button
    >
      <i class="material-icons"> menu </i>
    </a>
  </div>
  <div
    [ngStyle]="{ height: '32px', width: '32px' }"
    class="u-marginRight-16"
    fxFlex="32px"
  >
    <a
      [ngStyle]="{ height: '32px', width: '32px' }"
      aria-label="Go to homepage"
      i18n-aria-label="@@headerView.goToHomepageLabel"
      class="u-display-block"
      routerLink="/"
    >
      @if (tenant?.name) {
        <app-avatar-tenant [item]="tenant" class="u-display-block">
        </app-avatar-tenant>
      }
    </a>
  </div>
  <div
    class="text-subtitle-1"
    fxFlex="auto"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <!-- TODO(merci): revert previous implementation when route titles are localized https://github.com/tenthousandcoffees/web-client/issues/7888 -->
    @if (!tenant?.hidden_ui_items?.header_tenant_name) {
      <a class="u-marginRight-16" routerLink="/">
        {{ tenant?.friendly_name }}
      </a>
    }
    @if (title) {
      <div [fxShow]="false">
        {{ title }}
      </div>
    }
  </div>
  @if (authService.$isLoggedIn()) {
    @if (user) {
      <div
        [fxHide]="true"
        [fxHide.gt-sm]="false"
        fxFlex="none"
        fxLayout="row"
        fxLayoutAlign="start center"
        role="navigation"
      >
        @if (user.isAdmin) {
          <a
            class="u-display-block c-headerLinkItem color-grey"
            mat-button
            routerLink="/admin"
            routerLinkActive="mat-primary"
          >
            <p [ngStyle]="{ height: '18px' }" i18n="@@headerView.adminLabel">
              Admin
            </p>
          </a>
        }
        @if (isEligibleForAIAnnouncement()) {
          <button
            [ngStyle]="{ marginRight: '4px' }"
            (click)="openAIAnnouncementModal()"
            aria-label="AI features"
            i18n-aria-label="@@headerView.aiLabel"
            class="u-display-block c-headerLinkItem u-position-relative"
            mat-icon-button
            matTooltip="Get access to AI features today"
            i18n-matTooltip="@@headerView.aiTooltip"
          >
            <mat-icon
              [ngStyle]="{ verticalAlign: '0' }"
              class="md-18"
              fontSet="material-icons-outlined"
            >
              auto_awesome
            </mat-icon>
            @if (!hasSeenAIAnnouncement()) {
              <p
                [ngStyle]="{
                  backgroundColor: '#FAD24B',
                  fontSize: '10px',
                  padding: '0px 4px',
                  right: '-14px',
                  top: '6px',
                }"
                class="u-position-absolute u-borderRadius-button u-padding-2xsmall"
              >
                <b i18n="@@global.new">New</b>
              </p>
            }
          </button>
        }
        @if (tenant?.enabled_features?.conversations) {
          <button
            (click)="resetUnseenCount('conversations')"
            aria-label="Conversations"
            i18n-aria-label="@@headerView.conversationsLabel"
            class="u-display-block c-headerLinkItem u-position-relative"
            mat-icon-button
            matTooltip="Conversations"
            i18n-matTooltip="@@headerView.conversationsLabel"
            routerLink="/conversations"
            routerLinkActive="mat-primary"
          >
            <mat-icon
              [matBadge]="(header | async).unseenConversationsCount"
              [matBadgeHidden]="!(header | async).unseenConversationsCount"
              [ngStyle]="{ verticalAlign: '0' }"
              class="md-18"
              fontSet="material-symbols-outlined"
              matBadgeColor="warn"
              matBadgeSize="small"
            >
              chat
            </mat-icon>
          </button>
        }
        <button
          [ngClass]="{
            'has-notification': (header | async).unseenNotificationsCount,
          }"
          (click)="resetUnseenCount('notifications')"
          aria-label="Notifications"
          i18n-aria-label="@@headerView.notificationsLabel"
          class="u-display-block c-headerLinkItem u-position-relative"
          mat-icon-button
          matTooltip="Notifications"
          i18n-matTooltip="@@headerView.notificationsLabel"
          routerLink="/notifications"
          routerLinkActive="mat-primary"
        >
          <mat-icon
            [matBadge]="(header | async).unseenNotificationsCount"
            [matBadgeHidden]="!(header | async).unseenNotificationsCount"
            [ngStyle]="{ verticalAlign: '0' }"
            class="md-18"
            fontSet="material-symbols-outlined"
            matBadgeColor="warn"
            matBadgeSize="small"
          >
            notifications
          </mat-icon>
        </button>
        @if (tenant?.enabled_features?.localization) {
          <button
            (click)="openLanguageManager()"
            aria-label="Languages"
            i18n-aria-label="@@global.languages"
            class="u-marginRight-16"
            mat-icon-button
            matTooltip="Languages"
            i18n-matTooltip="@@global.languages"
          >
            <mat-icon [ngStyle]="{ verticalAlign: '0' }" class="md-18"
              >language</mat-icon
            >
          </button>
        }
        <button
          [matMenuTriggerFor]="menu"
          [ngStyle]="{ height: '32px', width: '32px' }"
          aria-label="Open profile menu"
          i18n-aria-label="@@headerView.openProfileMenuLabel"
          class="c-button"
        >
          @if (user._id) {
            <app-avatar-account [item]="user" class="u-display-block">
            </app-avatar-account>
          }
        </button>
        <mat-menu #menu="matMenu" [overlapTrigger]="false">
          <div [ngStyle]="{ 'min-width': '170px' }">
            <button
              [routerLink]="['/profile', user?.slug]"
              i18n="@@headerView.profileLabel"
              mat-menu-item
            >
              Profile
            </button>
            <button
              (click)="showZendesk()"
              i18n="@@headerView.askForHelpLabel"
              mat-menu-item
            >
              Ask for help
            </button>
            <button
              (click)="helpCenterClicked()"
              i18n="@@headerView.helpCenterLabel"
              mat-menu-item
            >
              Help center
            </button>
            <button
              [routerLink]="['/settings']"
              i18n="@@global.settings"
              mat-menu-item
            >
              Settings
            </button>
            <button
              (click)="logOut()"
              i18n="@@headerView.logOutLabel"
              mat-menu-item
            >
              Log out
            </button>
          </div>
        </mat-menu>
      </div>
    }
  }
</div>
<mat-sidenav-container
  [ngStyle]="{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    'z-index': 1000,
    'pointer-events': showDrawer ? 'initial' : 'none',
    opacity: showDrawer ? '1' : '0',
  }"
  class="bg-color-teal-50"
  role="navigation"
>
  <mat-sidenav
    #drawer
    [ngStyle]="{ width: '250px' }"
    (openedChange)="drawerOpenedChange($event)"
    class="u-padding-24-0"
  >
    <div class="u-padding-0-16">
      <app-avatar-account [item]="user" class="u-display-block">
      </app-avatar-account>
    </div>
    @if (routes?.length) {
      <mat-nav-list>
        @for (routeConfig of routes; track routeConfig) {
          <a
            [routerLink]="routeConfig.routerLink"
            (click)="drawer.close()"
            class="u-display-block"
            mat-list-item
          >
            {{ routeConfig.title }}
          </a>
        }
      </mat-nav-list>
      <mat-divider></mat-divider>
    }
    @if (user) {
      <mat-nav-list>
        @if (currentMembership?.document; as group) {
          <a
            [ngStyle]="{
              'background-color':
                group.background_color?.[0] ?? defaultBackgroundColor,
              color:
                group.background_color?.[0] ?? defaultBackgroundColor
                | appMostReadableColor,
            }"
            [routerLink]="['/hub', group.slug]"
            (click)="drawer.close()"
            mat-list-item
          >
            {{ group.name }}
          </a>
        }
        <a
          [routerLink]="['/profile', user.slug]"
          (click)="drawer.close()"
          i18n="@@headerView.profileLabel"
          mat-list-item
        >
          Profile
        </a>
        <a
          [routerLink]="['/conversations']"
          (click)="drawer.close()"
          i18n="@@headerView.conversationsLabel"
          mat-list-item
        >
          Conversations
        </a>
        <a
          [routerLink]="['/notifications']"
          (click)="drawer.close()"
          i18n="@@headerView.notificationsLabel"
          mat-list-item
        >
          Notifications
        </a>
        <a
          (click)="drawer.close()"
          appZendeskLink
          href="https://support.tenthousandcoffees.com"
          i18n="@@headerView.helpCenterLabel"
          mat-list-item
        >
          Help Center
        </a>
        @if (user.isAdmin) {
          <a
            [routerLink]="['/admin']"
            (click)="drawer.close()"
            i18n="@@headerView.adminLabel"
            mat-list-item
          >
            Admin
          </a>
        }
        @if (tenant?.enabled_features?.localization) {
          <button
            (click)="openLanguageManager()"
            class="c-button"
            i18n="@@header.languageLabel"
            mat-list-item
          >
            Language
          </button>
        }
        <a
          [routerLink]="['/settings']"
          (click)="drawer.close()"
          i18n="@@global.settings"
          mat-list-item
        >
          Settings
        </a>
        <a
          (click)="logOut(); drawer.close()"
          i18n="@@headerView.logOutLabel"
          mat-list-item
        >
          Log Out
        </a>
      </mat-nav-list>
    }
  </mat-sidenav>
</mat-sidenav-container>
